import React, { useEffect, useRef } from 'react';
import { ContentfulRichText } from 'common/components';
import { useClassName } from 'common/hooks';
import HomepageAsset from '../Asset';
import ChekMark from './check-mark.png';
import './thank-you.less';

export default function ThankYou({ step, insideModal }) {
  const classNames = useClassName('CLPFormThankYou');
  const { title, description, backgroundAsset } = step.fields;
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef) {
      containerRef.current.parentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className={classNames(
        'container',
        insideModal ? 'full-size' : 'default-size'
      )}>
      <HomepageAsset
        asset={backgroundAsset}
        settings={step.fields.settings}
        className={classNames('asset-bg')}
      />
      <div className={classNames('content')}>
        <img src={ChekMark} alt="Check" className={classNames('check')} />
        <p className={classNames('title')}>{title}</p>
        <section className={classNames('description')}>
          <ContentfulRichText field={{ 'en-US': description }} />
        </section>
      </div>
    </div>
  );
}
